import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { FaInstagram, FaEnvelope } from 'react-icons/fa'

import { useTheme } from '../../context/ThemeContext'

import { NavLink } from './navLink'
import { ThemeToggle } from './themeToogle'

import waze from '../../assets/waze_icon.png'
import gmaps from '../../assets/gmap_icon.png'
import uber from '../../assets/uber_icon.png'

import logo from '../../assets/logo.png'
import logoPositivo from '../../assets/logo_positivo.png'
import logoDark from '../../assets/logo_dark.png'

export function Header() {
 const [isOpen, setIsOpen] = useState(false)
 const [showMenu, setShowMenu] = useState(true)

 const { theme } = useTheme()
 const isDark = theme === 'dark'

 function toggleMenu() {
  setIsOpen(!isOpen)
 }

 useEffect(() => {
  function handleScroll() {
   const isDesktop = window.matchMedia('(min-width: 768px)').matches
   if (isDesktop) {
    setShowMenu(window.scrollY === 0)
   } else {
    setShowMenu(true)
   }
  }

  window.addEventListener('scroll', handleScroll)
  return () => window.removeEventListener('scroll', handleScroll)
 }, [])

 return (
  <header role="banner">
   <div
    className={clsx(
     'fixed right-0 top-0 h-full overflow-y-auto transition-all duration-500 ease-in-out z-20',
     isOpen ? 'w-full bgYellow' : 'w-0'
    )}
    aria-hidden={!isOpen}
   >
    {/* Menu */}
    {isOpen && (
     <div className="container" role="navigation" aria-label="Menu principal">
      <nav>
       <ul className="absolute top-36 max-[768px]:top-20 list-none">
        <NavLink link="home" onClick={toggleMenu} />
        <NavLink link="soluções" onClick={toggleMenu} />
        <NavLink link="trabalhos" onClick={toggleMenu} />
        <NavLink link="clientes" onClick={toggleMenu} />
        <NavLink link="contato" onClick={toggleMenu} />
        <div className="flex items-center gap-1 h-[66px]">
         <li>
          <Link
           to="https://www.instagram.com/admancriativa"
           target="_blank"
           aria-label="Instagram da Adman"
           className="hover:text-white text-black"
          >
           <FaInstagram size={23} aria-hidden="true" />
          </Link>
         </li>
         <li>
          <Link
           to="mailto:contato@admancriativa.com.br"
           target="_blank"
           aria-label="Enviar email para Adman"
           className="hover:text-white text-black"
          >
           <FaEnvelope size={23} aria-hidden="true" />
          </Link>
         </li>
        </div>
        <ThemeToggle />
        <div className="hidden max-[767px]:block fixed bottom-3">
         <p className="text-black font-normal text-base font-['rns-milesregular']">
          A gente sabe que o seu tempo é precioso.
          <br /> Então escolha qual aplicativo vai trazer você mais
          <br /> rápido até a Adman.
          <br />
          <br />
          <span
           className="flex gap-1"
           role="group"
           aria-label="Links para apps de navegação"
          >
           <Link
            to="waze://?q=Av. Av. Nicolas Boer, 399 - São Paulo - SP 01140-060"
            target="_blank"
            aria-label="Abrir no Waze"
            className="w-[10%]"
           >
            <img src={waze} alt="Waze" />
           </Link>
           <Link
            to="http://maps.google.com/maps?q=Av. Nicolas Boer, 399 - São Paulo - SP 01140-060"
            target="_blank"
            aria-label="Abrir no Google Maps"
            className="w-[10%]"
           >
            <img src={gmaps} alt="Google Maps" />
           </Link>
           <Link
            to="https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[formatted_address]=Avenida%20Nicolas%20Boer,%20399%20-%20Barra%20Funda&dropoff[latitude]=-23.5198029&dropoff[longitude]=-46.682725"
            target="_blank"
            aria-label="Chamar Uber"
            className="w-[10%]"
           >
            <img src={uber} alt="Uber" />
           </Link>
          </span>
         </p>
        </div>
       </ul>
      </nav>
     </div>
    )}
   </div>
   {showMenu && (
    <div
     className={
      isOpen
       ? 'fixed w-full h-[70px] z-20 max-[768px]:bgYellow'
       : isDark
       ? 'fixed w-full h-[70px] z-20 max-[768px]:bg-black'
       : 'fixed w-full h-[70px] z-20 max-[768px]:bg-white'
     }
    >
     <div className="container py-4 flex items-center justify-between">
      {/* Logo */}
      {/* <a
       href="/"
       className={clsx(
        'adman_logo w-[160px] h-[35px] relative -left-[18px] z-[1001]',
        isOpen && 'adman_logo_positive',
        !isOpen && isDark && 'adman_logo_dark'
       )}
       aria-label="Voltar para página inicial"
      >
       <span className="sr-only">Adman Logo</span>
      </a> */}
      <a
       href="/"
       className="relative w-[160px] h-[35px] -left-[18px] z-[1001]"
       aria-label="Voltar para página inicial"
      >
       <span className="sr-only">Adman Logo</span>
       <img
        src={isOpen ? logoPositivo : isDark ? logoDark : logo}
        alt="Logo da Adman"
        className="w-full h-full object-contain"
        loading="eager"
        decoding="async"
       />
      </a>

      {/* Botão mobile */}
      <button
       type="button"
       className={clsx(
        'relative z-10 block self-end',
        isOpen
         ? 'hamburger hamburger--spin is-active'
         : 'hamburger hamburger--spin'
       )}
       onClick={toggleMenu}
       aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
       aria-expanded={isOpen}
       aria-controls="menu"
      >
       <span className="hamburger-box">
        <span className="hamburger-inner"></span>
       </span>
      </button>
     </div>
    </div>
   )}
  </header>
 )
}
